import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../../../useTexts'
import { useValues } from './hooks/useValues'

import { form } from '../../../formState'

export function UnsubscribeInstructions() {
  const { showWarningCard, notificationWay } = useValues()
  const texts = useTexts()

  const warningCardText =
    notificationWay === 'EMAIL'
      ? texts.unsubscribeInstructionsAlertTextEmail
      : texts.unsubscribeInstructionsAlertTextPhone

  return (
    <>
      <form.Checkbox
        helperText={texts.unsubscribeInstructionsHelperText}
        name="includeMessageUnsubscriptionInstructions"
        testId="includeMessageUnsubscriptionInstructions"
        label={texts.unsubscribeInstructionsLabel}
        validateOn="focus blur"
      />

      {showWarningCard && (
        <Alert severity="warning">
          <AlertTitle>{texts.unsubscribeInstructionsAlertTitle}</AlertTitle>
          {warningCardText}
        </Alert>
      )}
    </>
  )
}
